import { useIsDexcomSteloSensorMode } from '@src/utils/hooks'
import { useIsIndirectSyncSensorMode, useSyncsGlucoseViaAppleOrGoogle } from '../hooks'
import { useIsOwnSensorGlucoseDetected } from './useIsOwnSensorGlucoseDetected'
import { useShowByosDataInfoUi } from './useShowByosDataInfoUi'
import { useIsDexcomG6G7Realtime } from './useIsDexcomG6G7Realtime'

export const useShowByosThirdPartyDelaySyncInfo = () => {
  // User is eligible for BYOS integration UI
  const shouldShowByosDataDelayUi = useShowByosDataInfoUi()

  // User has already synced via BYOS successfully in the past
  const isOwnSensorGlucoseDetected = useIsOwnSensorGlucoseDetected()

  // Has a relevant sensor mode or syncing configuration
  const syncsGlucoseViaAppleOrGoogle = useSyncsGlucoseViaAppleOrGoogle()
  const isIndirectSyncSensorMode = useIsIndirectSyncSensorMode()
  const isDexcomSteloSensorMode = useIsDexcomSteloSensorMode()

  // User is already syncing using another method
  const isDexcomG6G7Realtime = useIsDexcomG6G7Realtime()

  if (
    isDexcomG6G7Realtime ||
    !shouldShowByosDataDelayUi ||
    !isOwnSensorGlucoseDetected ||
    isIndirectSyncSensorMode ||
    isDexcomSteloSensorMode
  ) {
    return false
  }

  return syncsGlucoseViaAppleOrGoogle
}
